import { useState } from 'react';
import { toTeamTO, type TeamTO } from '../../../../lib';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { post } from '../../../../api/baseUrl';

export const useGetTeams = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [teams, setTeams] = useState<TeamTO[]>([]);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const postGetTeams = async (hospitalIds: number[]): Promise<TeamTO[]> => {
    if (hospitalIds.length > 0 && selectedTenancy) {
      setIsLoading(true);
      try {
        const payload = {
          clinicIds: hospitalIds,
          tenancyId: selectedTenancy.tenancy_id,
        };
        const { data } = await post(`getTeams`, { ...payload });
        const mapped = data.data.map((item: any) => toTeamTO(item));
        setTeams(mapped);
        return mapped;
      } catch (error: any) {
        console.error('An error occurred during get teams', error);
        setErrorMessage(
          error?.response?.data?.message || 'Unknown error in get teams',
        );
        return [];
      } finally {
        setIsLoading(false);
      }
    }
    return [];
  };

  return {
    postGetTeams,
    errorMessage,
    isLoading,
    teams,
  };
};
